Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "InfoIcon15413052",
  {"root":"InfoIcon15413052--root","icon":"InfoIcon15413052--icon"},
  ".InfoIcon15413052--root{display:inline-block;line-height:0;color:#3899ec}.InfoIcon15413052--icon{vertical-align:middle}",
  2,
  "InfoIcon15413052"
);
__webpack_require__.stylable.$.register(exports.default)
